"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiService = void 0;
class AiService {
    constructor(baseUrl, token, company) {
        this.BASE_URL = baseUrl;
        this.TOKEN = (token || '').toString();
        this.company = company;
    }
    getRequestHeaders() {
        return new Headers({
            Accept: 'application/json',
            Authorization: `Basic ${this.TOKEN}`,
            'Content-Type': 'application/json',
        });
    }
    generateText(query) {
        const endpoint = `${this.BASE_URL}brand/companies/${this.company}/ai`;
        const result = fetch(endpoint, {
            method: 'POST',
            headers: this.getRequestHeaders(),
            body: JSON.stringify({
                type: 'text',
                prompt: query,
            }),
        })
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error();
        })
            .then((result) => ({
            result,
            success: true,
        }))
            .catch((error) => ({
            success: false,
            error: error,
            result: 'Oops, something went wrong',
        }));
        return result;
    }
    generateImage(query, imageStyle, outputFormat, size) {
        const endpoint = `${this.BASE_URL}brand/companies/${this.company}/ai`;
        const style = imageStyle !== 'none' ? imageStyle : undefined;
        const result = fetch(endpoint, {
            method: 'POST',
            headers: this.getRequestHeaders(),
            body: JSON.stringify({
                type: 'image',
                prompt: query,
                format: outputFormat,
                style,
                size,
            }),
        })
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error();
        })
            .then((result) => ({
            result,
            success: true,
        }))
            .catch((error) => ({
            success: false,
            error: error,
            result: 'Oops, something went wrong',
        }));
        return result;
    }
    generateLogo(query, data, outputFormat) {
        const endpoint = `${this.BASE_URL}brand/companies/${this.company}/ai/logo`;
        const style = data.logoStyle !== 'none' ? data.logoStyle : undefined;
        const result = fetch(endpoint, {
            method: 'POST',
            headers: this.getRequestHeaders(),
            body: JSON.stringify({
                prompt: query,
                format: outputFormat,
                scenario: 'simple_company_logo',
                style,
                colour: data.logoColor,
                company_name: data.company,
                include_company_name: data.includeCompanyName,
                industry_name: data.industryName,
            }),
        })
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error();
        })
            .then((result) => ({
            result,
            success: true,
        }))
            .catch((error) => ({
            success: false,
            error: error,
            result: 'Oops, something went wrong',
        }));
        return result;
    }
}
exports.AiService = AiService;
//# sourceMappingURL=ai.service.js.map